import axios from "axios";
import { APPLY_PROPERTY } from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getapplyPropertyList = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}apply/property/user/get`);

    dispatch({
      type: APPLY_PROPERTY,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};
